import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import ExperienceRecentlyViewedTile from '../ExperienceTiles/ExperienceRecentlyViewedTile'
import { connect } from 'react-redux'
import ExperienceRecentlyViewedSkeletonTile from '../ExperienceTiles/ExperienceRecentlyViewedSkeletonTile'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { arrayToMap, take } from 'lib/array/arrayUtils'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import useExperiences from 'hooks/Experiences/useExperiences'

interface Props {
  recentlyViewedExperienceIds: Array<string>
}

function ExperiencesPageRecentlyViewedExperiences(props: Props) {
  const { recentlyViewedExperienceIds } = props
  const intl = useIntl()

  const experienceIds = useMemo(() => take(recentlyViewedExperienceIds, 3), [recentlyViewedExperienceIds])
  const [experiences] = useExperiences(experienceIds)
  const experiencesById = useMemo(() => arrayToMap(experiences, exp => exp.id), [experiences])

  if (recentlyViewedExperienceIds.length === 0) {
    return null
  }

  return (<VerticalSpacer gap={12}>
    <BodyText variant="medium" weight="bold">
      {intl.formatMessage({
        id: 'SjK1JIMVhn',
        defaultMessage: 'Recently viewed',
        description: 'Heading for recently viewed experiences section on the experiences landing page',
      })}
    </BodyText>
    <CardCarousel pageSize={3} width={rem(370)}>
      {experienceIds.map((id, index) => <React.Fragment key={id}>
        {!experiencesById.has(id) && <ExperienceRecentlyViewedSkeletonTile />}
        {experiencesById.has(id) && <ExperienceRecentlyViewedTile experience={experiencesById.get(id)!} position={index} />}
      </React.Fragment>)}
    </CardCarousel>
  </VerticalSpacer>
  )
}

function mapStateToProps(state: App.State) {
  return {
    recentlyViewedExperienceIds: state.experience.recentlyViewedExperienceIds,
  }
}

export default connect(mapStateToProps)(ExperiencesPageRecentlyViewedExperiences)
